/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Voice_TypeInputs */

const en_dialog_voice_type = /** @type {(inputs: Dialog_Voice_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice type`)
};

const es_dialog_voice_type = /** @type {(inputs: Dialog_Voice_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de voz`)
};

/**
* | output |
* | --- |
* | "Voice type" |
*
* @param {Dialog_Voice_TypeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_voice_type = /** @type {((inputs?: Dialog_Voice_TypeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Voice_TypeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_voice_type(inputs)
	return en_dialog_voice_type(inputs)
});